
import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'meeting-calendar',
    template: 'meetingCalendar.component.html',
  standalone: false
})

export class MeetingCalendarComponent implements OnInit {
    constructor() { }

    ngOnInit() {
        document.querySelector("body").classList.remove("opened");
     }
}